import styled from "@emotion/styled";

export const StyledSkeleton = styled.span<{
  $height: number | string;
  $width: number | string;
  $animationDelay: number;
  $disableAnimation: boolean;
  $startColor?: string;
  $middleColor?: string;
  $endColor?: string;
}>`
  display: inline-block;
  position: relative;
  overflow: hidden;
  background-color: ${({ theme, $startColor }) =>
    $startColor || theme.colors.background.skeleton.start};
  border-radius: 8px;
  height: ${({ $height }) => (typeof $height === "number" ? `${$height}px` : $height)};
  width: ${({ $width }) => (typeof $width === "number" ? `${$width}px` : $width)};

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      ${({ theme, $endColor }) => $endColor || theme.colors.background.skeleton.end} 0%,
      ${({ theme, $middleColor }) => $middleColor || theme.colors.background.skeleton.middle} 20%,
      ${({ theme, $middleColor }) => $middleColor || theme.colors.background.skeleton.middle} 60%,
      ${({ theme, $endColor }) => $endColor || theme.colors.background.skeleton.end} 100%
    );
    animation: ${({ $disableAnimation }) => ($disableAnimation ? "none" : "shimmer 2s infinite")};
    content: "";
    animation-delay: ${({ $animationDelay }) => $animationDelay}ms;
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`;
